import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        a: {
          color: '#252528 !important',
          fontWeight: '600'
        }
      }
    }
  },
  typography: {
    fontFamily: [
      'sec-400'
    ].join(','),
  },
  palette: {
    primary: {
      main: '#0381FE',
      dark: '#0072DE',
      active: '#3E91FF',
    },
    secondary: {
      main: '#008CFF',
    },
    text: {
      primary: '#252528',
      secondary: '#252528',
      disabled: '#8C8C8C',
      link: '#252528',
      agreeTitle: '#252528',
      checkboxTitle: '#010102',
      optionalText: '#4D4D52',
      checkboxDescription: '#848487',
      descriptionLink: '#8C8C91',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FAFAFA',
      tooltip: '#FCFCFC',
    },
    divider: '#E6E6E6',
  },
});

export default theme;
